import {clsx, type ClassValue} from "clsx";
import {twMerge} from "tailwind-merge";

// twMerge resolves conflicts by last-wins, so a caller's className beats the variant's classes.
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
